import { useAuthMutation } from "@bn/api";
import { createOrUpdateBookings } from "@api/v1/methods";

export const useCreateOrUpdateBookings = () => {
  return useAuthMutation(createOrUpdateBookings, {
    throwOnError: true,
  });
};
